<template>
  <div class="w-screen h-screen overflow-hidden">
    <div class="w-full h-full relative">
      <div class="w-full h-full overflow-auto" :class="[extraClass]">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdapterFrame',
  props: {
    extraClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
};
</script>
